import { ChangePasswordButton } from "../settings/ChangePasswordButton.js";
import { CommunicationPreferencesButton } from "../settings/communicationPreferences/CommunicationPreferencesButton.js";
import { GoogleCalendarSection } from "../settings/GoogleCalendarSection.js";
import { MfaSection } from "../settings/MfaSection.js";
import { AppVersion } from "../settings/AppVersion.js";
import { FixtureSwitchVisibilityToggle } from "../dev/FixtureSwitchVisibilityToggle.js";
import settingsStyles from "../settings/SettingsScreen.module.scss";

/**
 * Account tab — the caller's own password, opening the SAME `ChangePasswordModal` the band Settings modal's
 * Account tab does. Person-scoped: nothing here knows or cares which org you are acting for, which is
 * exactly what lets one component serve both shells.
 *
 * It has no capability gate, and that is why the dialog still opens for a staffer: the roster shell has no
 * Settings gear, so this is an org seat's only door to their own password.
 *
 * The band side lists artist / role / email / member-since above this link; there is no org-scoped
 * equivalent to show (the read behind those rows is band-scoped). No "Your account" heading on either tab
 * (PO, 2026-10-09): every row now carries its own label.
 *
 * Google Calendar sits under it for the same reason it sits on the band tab: it is the person's own calendar, and a
 * manager on a show's member list gets that show on it like anyone else.
 */
export function OrgSettingsAccountTab() {
  return (
    <div className={settingsStyles.stack}>
      <div className={settingsStyles.accountLinks}>
        <CommunicationPreferencesButton />
        <ChangePasswordButton />
      </div>
      <MfaSection />
      <GoogleCalendarSection />
      <FixtureSwitchVisibilityToggle />
      <AppVersion />
    </div>
  );
}
